if ($("header#header").length) {
  if (!$('a.cart-count i[data-testid="headerCartCount"]').length) {
    $('a[data-target="cart"]').append('<i data-testid="headerCartCount">0</i>');
  }
  $(".top-navigation-bar .container").prepend($("#footer .topUsps").clone());
  $(".top-navigation-bar .project-phone").after("<span>" + translation('telefonInfo') + "</span>");
  $(".header-top").append($(".top-navigation-bar .responsive-tools").clone());
  $(".header-top .responsive-tools").prepend($(".top-navigation-tools .dropdown").clone());
  $(".header-top .responsive-tools").append('<a class="poradna" href="'+translation('urlporadna')+'">'+translation('textporadna')+'</a>');

  // .top-navigation-bar je na mobilu skrytý – výběr měny a jazyka přesuneme do #navigation
  // Vlastní markup (klon Shoptet dropdownu by neměl obsluhu ani styly).
  var $mobileLanguages = $('<div class="mobileLanguages"></div>');

  $(".top-navigation-bar .languagesMenu__box").each(function () {
    var $box = $(this);
    var $links = $box.find(".languagesMenu__list a");
    var $list = $('<ul class="mobileDrop__list"></ul>');

    $links.each(function () {
      var $link = $(this);
      var name = $.trim($link.text());
      var isActive = $link.find(".languagesMenu__list__name--actual").length > 0 ||
        name === $.trim($box.find(".languagesMenu__header--actual").clone().children().remove().end().text());

      $list.append(
        $("<li></li>").append(
          $('<a rel="nofollow"></a>')
            .attr("href", $link.attr("href"))
            .toggleClass("active", isActive)
            .text(name)
        )
      );
    });

    var $drop = $('<div class="mobileDrop"></div>');
    var $btn = $('<button type="button" class="mobileDrop__btn"></button>');
    $('<span class="mobileDrop__label"></span>')
      .text($.trim($box.find(".languagesMenu__header--name").text()))
      .appendTo($btn);
    $('<span class="mobileDrop__value"></span>')
      .text($.trim($box.find(".languagesMenu__header--actual").clone().children().remove().end().text()))
      .appendTo($btn);
    $('<span class="caret"></span>').appendTo($btn);

    $drop.append($btn, $list).appendTo($mobileLanguages);
  });

  if ($mobileLanguages.children().length) {
    $("#navigation").append($mobileLanguages);
  }

  $(document).on("click", ".mobileDrop__btn", function () {
    var $drop = $(this).closest(".mobileDrop");
    $(".mobileDrop").not($drop).removeClass("open");
    $drop.toggleClass("open");
  });

  $('.navigation-buttons a[data-target="cart"]').clone().appendTo(".header-top .responsive-tools");
  $('<span class="close"></span>').appendTo(".login-widget .popup-widget-inner #customerLogin");

  $(".header-top .responsive-tools").append($(".header-top .site-name-wrapper").clone());
  $(document).on("click", ".login-widget .popup-widget-inner .close", function () {
    $("body").removeClass("user-action-visible login-window-visible");
  });



  document.querySelector(".login-widget").addEventListener(
    "mouseleave",
    function (e) {
      e.stopImmediatePropagation();
    },
    true
  );

  $(document).ready(function () {
    let target = "cart";
    let timeout;
    const $cartHoverArea = $('a[data-target="cart"]');
    $cartHoverArea.on("mouseenter", function () {
      var show = target === "cart" && !$('a[data-target="cart"]').hasClass("full") ? false : true;
      shoptet.popups.showPopupWindow(target, show);
    });
  });
}
$(".siteCookies__links").append($(".siteCookies__buttonWrap button"));
